/* eslint-disable no-restricted-globals */
const territories = new Set([
  /* "United States", */
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  /* "Federated States Of Micronesia", */
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  /* "Marshall Islands", */
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  /* "Palau", */
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
])

function isMultistate(tags) {
  return tags.some(tag => territories.has(tag)) && tags.filter(tag => territories.has(tag)).length > 1;
}

function createStampCopies(stamp) {
  const baseLongitude = parseFloat(stamp.metafields.nodes[1].value);
  const plus360 = { ...stamp, metafields: { ...stamp.metafields, nodes: [{ ...stamp.metafields.nodes[0]}, { ...stamp.metafields.nodes[1], value: `${baseLongitude + 360}`}]}};
  const minus360 = { ...stamp, metafields: { ...stamp.metafields, nodes: [{ ...stamp.metafields.nodes[0]}, { ...stamp.metafields.nodes[1], value: `${baseLongitude - 360}`}]}};
  const multistate = isMultistate(stamp.tags);
  stamp.multistate = plus360.multistate = minus360.multistate = multistate;
  return [stamp, plus360, minus360];
}

function createStampDefault(stamp) {
  const multistate = isMultistate(stamp.tags);
  stamp.multistate = multistate;
  return [stamp];
}

addEventListener('message', function(e) {
  const { category, allStamps, makeCopies } = e.data;
  const processedStamps = makeCopies ? allStamps.flatMap(createStampCopies) : allStamps.flatMap(createStampDefault);
  postMessage({ category, processedStamps });
});
